module.exports = __webpack_public_path__ + "img/ral-finance.444f7b5a.svg";